import { DOMAIN } from "@/lib/constants";
import { jwtDecode } from "jwt-decode";
import { NextRequest } from "next/server";
import { Cookies } from "react-cookie";

const cookies = new Cookies();
export const AUTH_COOKIE_NAME = "_yadAlBaraka_auth_";
export const LANG_COOKIE_NAME = "_yadAlBaraka_Lang_";
export const PHONE_CODE_COOKIE_NAME = "_yadAlBaraka_Phone_";

export const sign = (accessToken: string) => {
  cookies.set(AUTH_COOKIE_NAME, accessToken, {
    secure: false,
    domain: DOMAIN,
    path: "/",
    sameSite: "strict",
    maxAge: 60 * 60 * 24 * 6,
  });
};

export const Lang = (lang: string) => {
  cookies.set(LANG_COOKIE_NAME, lang, {
    secure: true,
    domain: DOMAIN,
    path: "/",
    sameSite: "strict",
    maxAge: 60 * 60 * 24 * 6,
  });
};

export const PhoneCode = (code: string) => {
  cookies.set(PHONE_CODE_COOKIE_NAME, code, {
    secure: true,
    domain: DOMAIN,
    path: "/",
    sameSite: "strict",
    maxAge: 60 * 60 * 24 * 6,
  });
};

export const logout = () => {
  cookies.remove(AUTH_COOKIE_NAME, {
    domain: DOMAIN,
    path: "/",
    sameSite: "strict",
  });
};

export const getCookie = (cname: string) => {
  return cookies.get(cname);
};

const isTokenExpired = (token?: string) => {
  if (!token) return true;

  try {
    const decodedToken = jwtDecode(token);
    if (!decodedToken.exp) return true;

    const currentTime = Date.now() / 1000;
    return decodedToken.exp < currentTime;
  } catch {
    return true;
  }
};

export const isAuthenticated = (): boolean => {
  const authCookie = cookies.get(AUTH_COOKIE_NAME);
  if (authCookie) return !isTokenExpired(authCookie);
  return false;
};

export const getCurrentUserMiddleware = (req: NextRequest) => {
  const userCookie = req.cookies.get(AUTH_COOKIE_NAME);
  if (userCookie && typeof userCookie.value === "string") {
    const decodeToken = jwtDecode<any>(userCookie.value);
    if (decodeToken) return decodeToken;
  }

  return undefined;
};

export const getCurrentUser = (): any => {
  const authCookie = cookies.get(AUTH_COOKIE_NAME);
  if (authCookie && typeof authCookie === "string") {
    return jwtDecode<any>(authCookie);
  }
  return null;
};
export const doesPathMatchPattern = (
  path: string,
  pattern: string,
): boolean => {
  const regexPattern = new RegExp(
    "^" + pattern.replace(/\[.*?\]/g, "[^/]+") + "$",
  );
  return regexPattern.test(path);
};
export const isMatchingRoute = (
  path: string,
  routeSet: Set<string>,
): boolean => {
  for (const route of routeSet) {
    if (doesPathMatchPattern(path, route)) {
      return true;
    }
  }
  return false;
};
export const ADMIN_ROUTES = new Set([
  "/dashboard",
  "/dashboard/about",
  "/dashboard/plan-your-visit",
  "/dashboard/contacts",
  "/dashboard/social-links",
  "/dashboard/blogs",
  "/dashboard/blogs/[id]/edit",
  "/dashboard/blogs/new",
  "/dashboard/blogs/[id]/edit",
  "/dashboard/blogs/new",
  "/dashboard/blogs/[id]/edit",
  "/dashboard/events",
  "/dashboard/events/[id]/edit",
  "/dashboard/events/new",
  "/dashboard/services",
  "/dashboard/donate",
  "/dashboard/contact",
  "/dashboard/volunteer",
  "/dashboard/volunteers",
  "/dashboard/governorates",
  "/dashboard/meta",
]);

export const USER_ROUTES = new Set([]);

export const AUTH_ROUTES = new Set([
  ...Array.from(ADMIN_ROUTES),
  ...Array.from(USER_ROUTES),
]);
export const UNAUTH_ROUTES = new Set(["/order/[ref]"]);
export const LOGIN_ROUTES = new Set(["/login"]);
export const UNDER_CONSTRUCTION_ROUTES = new Set(["/home"]);
export const MARKETING_ROUTES = new Set([
  "/",
  "/about",
  "/plan-your-visit",
  "/contact",
  "/events",
  "/news",
  "/services",
  "/photos",
  "/videos",
  "/donate",
  "/services/[slug]",
  "/volunteer",
  "/blogs",
  "/donate-now",
  "/blogs/[id]",
]);
